import Base from './components/cells/Base';
import RowNumber from './components/cells/RowNumber';

export default function RowNumberCell() {}

RowNumberCell.prototype.init = function (params) {
    this.eGui = Base(RowNumber(params), params);
    return;
};

RowNumberCell.prototype.getGui = function () {
    return this.eGui;
};
